import { Container, Row, Col, Card, Badge, Button } from 'react-bootstrap';
import { motion } from 'motion/react';
import brandData from '../../data/brandData.json';
import logo from "../../assets/logo-sm.png";
import authImg from "../../assets/auth_img.jpg";

const HeroSection = () => {
  const { hero } = brandData

  const cardVariants = {
    hidden: { opacity: 0, x: -50 },
    visible: {
      opacity: 1,
      x: 0,
      transition: { duration: 0.6, ease: "easeOut" }
    }
  }

  const contentVariants = {
    hidden: { opacity: 0, x: 50 },
    visible: {
      opacity: 1,
      x: 0,
      transition: { duration: 0.6, ease: "easeOut" }
    }
  }

  return (
    <section className="min-vh-100 w-100 d-flex align-items-center justify-content-center">
      <div className="position-absolute w-100 h-100 bg-opacity-50 z-0">
        <img src={authImg} alt="auth-bg" className="w-100 h-100 opacity-25" />
      </div>
      <Container className="position-relative z-1">
        <Row className="align-items-center g-4">
          <Col lg={6}>
            <motion.div variants={cardVariants} initial="hidden" animate="visible">
              <Card className="border-0 shadow rounded-4 bg-white bg-opacity-25 position-relative">
                <Card.Body className="p-4">
                  <div className="d-flex align-items-center mb-3">
                    <img src={logo} alt="brand-mark" height="36" className="me-2" />
                    <h5 className="mb-0">{hero.brandKit.title}</h5>
                  </div>
                  <p className="text-secondary small mb-3">{hero.brandKit.description}</p>
                  <ul className="list-unstyled lh-lg small mb-3">
                    {hero.brandKit.features.map((feature, idx) => (
                      <motion.li  className="d-flex align-items-center"
                        key={idx}
                        initial={{ opacity: 0, x: -10 }}
                        animate={{ opacity: 1, x: 0 }}
                        transition={{ delay: idx * 0.1 + 0.3 }}
                      >
                        <i className={`${feature.icon} text-primary me-2`}></i> {feature.text}
                      </motion.li>
                    ))}
                  </ul>

                  <div className="p-3 bg-light border rounded-3 mb-3">
                    <div className="d-flex align-items-center mb-2">
                      <i className="ri-chat-quote-line text-success me-2"></i>
                      <strong>{hero.brandKit.messaging.title}</strong>
                    </div>
                    <ul className="list-unstyled lh-lg small mb-0">
                      {hero.brandKit.messaging.items.map((item, idx) => (
                        <li key={idx} className="d-flex align-items-center">
                          <i className="ri-checkbox-circle-line text-success me-2"></i> {item}
                        </li>
                      ))}
                    </ul>
                  </div>

                  <div className="d-flex flex-wrap gap-2">
                    {hero.brandKit.applications.map((app, idx) => (
                      <motion.div key={idx} whileHover={{ scale: 1.05 }}>
                        <Badge bg="light" text="secondary" className="border">{app}</Badge>
                      </motion.div>
                    ))}
                  </div>
                </Card.Body>
              </Card>
            </motion.div>
          </Col>
          <Col lg={5} className="offset-lg-1">
            <motion.div variants={contentVariants} initial="hidden" animate="visible">
              <motion.h2  className="display-5 fw-semibold mb-2 text-gradiant"
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.2 }}
              >
                {hero.title}
              </motion.h2>
              <motion.p  className="text-secondary mb-3"
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.3 }}
              >
                {hero.subtitle}
              </motion.p>
              <div className="d-flex flex-wrap gap-2 mb-4">
                {hero.badges.map((badge, idx) => (
                  <motion.div
                    key={idx}
                    initial={{ opacity: 0, scale: 0.8 }}
                    animate={{ opacity: 1, scale: 1 }}
                    transition={{ delay: idx * 0.1 + 0.4 }}
                    whileHover={{ scale: 1.05 }}
                  >
                    <Badge bg={`${badge.variant}-subtle`} text={badge.variant} className={`border border-${badge.variant}-subtle`}>
                      {badge.text}
                    </Badge>
                  </motion.div>
                ))}
              </div>
              <motion.div className="d-flex flex-wrap gap-2 align-items-center"
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.5 }}
              >
                <motion.div whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.95 }}>
                  <Button variant="success" href="#brand-packages">Explore Packages</Button>
                </motion.div>
                <motion.div whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.95 }}>
                  <Button variant="outline-primary" href="#contact-brand">Talk to a Strategist</Button>
                </motion.div>
              </motion.div>
              <motion.div className="d-flex gap-4 mt-4"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ delay: 0.6 }}
              >
                {hero.stats.map((stat, idx) => (
                  <motion.div
                    key={idx}
                    whileHover={{ y: -5 }}
                  >
                    <h4 className="mb-0">
                      {stat.icon && <i className={`${stat.icon} text-warning`}></i>} {stat.value}
                    </h4>
                    <small className="text-secondary">{stat.label}</small>
                  </motion.div>
                ))}
              </motion.div>
            </motion.div>
          </Col>
        </Row>
      </Container>
    </section>
  )
}

export default HeroSection;
